document.addEventListener("DOMContentLoaded", function () {
    ctaSectionCarousel()

    // Add event listener to the window object
    window.addEventListener("resize", debounce(ctaSectionCarousel, 300))

    function ctaSectionCarousel(){
        const ctaSections = document.querySelectorAll('.cta-section.glide')
        const mobileWidth = 959
        
        if (ctaSections != null && ctaSections.length > 0) {
            ctaSections.forEach((ctaSection, i) => {
                const slides = ctaSection.querySelectorAll('.cta-section__card')
    
                if (ctaSection.classList.contains('cta-section--image')) {
                    // With image
                    var glide = new Glide(ctaSection, {
                        type: 'carousel',
                        gap: 24,
                        perView: 1
                    })
                    if (slides.length > 1) {
                        glide.mount()
                    }
                } else {
                    // Without image
                    var glide = new Glide(ctaSection, {
                        type: 'carousel',
                        gap: 24,
                        perView: 2,
                        breakpoints: {
                            [mobileWidth]: {
                                perView: 1
                            }
                        }
                    })
                    // Desktop
                    if (screen.width > mobileWidth) {
                        // Desktop
                        // Initialize glidejs if there are more than 2 slides
                        if (slides.length > 2) {
                            glide.mount()
                        }
                    } else {
                        // Mobile
                        // Initialize glidejs if there are more than 1 slide
                        if (slides.length > 1) {
                            glide.mount()
                        }
                    }
                }
            })
        }
    }
})